import { Button } from "antd-v5";
import ColumnFilterKeyValue from "components/ColumnFilterKeyValue";
import useSyncState from "hooks/useSyncState";
import { map } from "lodash";
import React, { useEffect, useState } from "react";
import { KeyValue } from "types/tenantConfig";

import ACTrigger from "ac-components/ACTrigger";

export default function ACTagFilterField({
  value,
  onChange,
}: {
  value: KeyValue[];
  onChange: (value: KeyValue[]) => void;
}) {
  const [popupVisible, setPopupVisible] = useState(false);
  const [getSelectedKeys, setSelectedKeys] = useSyncState(value);
  const selectedKeys = getSelectedKeys();
  useEffect(() => {
    setSelectedKeys(value);
  }, [value, popupVisible, setSelectedKeys]);

  return (
    <ACTrigger
      popup={
        <ColumnFilterKeyValue
          selectedKeys={selectedKeys}
          visible={popupVisible}
          confirm={() => {
            onChange(getSelectedKeys());
            setPopupVisible(false);
          }}
          setSelectedKeys={setSelectedKeys}
          clearFilters={() => {
            onChange([]);
            setPopupVisible(false);
          }}
        />
      }
      onPopupVisibleChange={setPopupVisible}
      popupVisible={popupVisible}
      placement="bottomRight"
      trigger="click"
      offsetY={10}
    >
      <Button block>
        <div className="text-left">
          {value && value.length ? (
            map(value, ColumnFilterKeyValue.filterLabelFormatter).join(", ")
          ) : (
            <div className="text-placeholder">Tags</div>
          )}
        </div>
      </Button>
    </ACTrigger>
  );
}
